export const supportUrls = Object.freeze({
  teamsOfService: 'https://www.saleshandy.com/terms/',
  emailVerificationBlog:
    'https://docs.saleshandy.com/en/articles/6970056-email-verification-what-why-and-how-to-set-it-up-in-saleshandy',
  scheduleCall:
    'https://www.saleshandy.com/demo/?utm_source=webapp&utm_medium=top_right_button&utm_campaign=product_demo_v3/',
  refundPolicy: 'https://docs.saleshandy.com/en/articles/6969685-refund-policy',
  becomeOurAffiliate:
    'https://www.saleshandy.com/affiliate-program/?utm_source=inapp&utm_medium=direct&utm_campaign=affiliate',
  warmupFaq:
    'https://docs.saleshandy.com/en/articles/7146556-transition-to-trulyinbox-for-email-warm-up',
  outreachPlanViewFAQ:
    'https://docs.saleshandy.com/en/articles/6980297-everything-about-saleshandy-s-pricing-and-plans',
  dialerPlanViewFAQ:
    'https://docs.saleshandy.com/en/articles/14634054-how-saleshandy-dialer-credits-work-and-how-much-each-call-costs',
  dialerPurchaseNumberLearnMoreLink:
    'https://docs.saleshandy.com/en/articles/14633731-how-to-purchase-and-manage-phone-numbers-in-saleshandy-dialer',
  dialerCallOutcomeLearnMoreLink:
    'https://docs.saleshandy.com/en/articles/14635577-how-to-manage-call-outcomes-in-saleshandy-dialer',
  leadFinderPlanViewFAQ:
    'https://docs.saleshandy.com/en/articles/8778847-saleshandy-lead-finder-pricing-plans',
  leadFinderExtensionGuide:
    'https://app.notion.com/p/Getting-Started-with-Saleshandy-LinkedIn-Chrome-Extension-271e953897188007bf33d54b04ccf81e',
  updateCardDetails:
    'https://billing.stripe.com/p/login/14kbJC7H05AW8qk9AA?prefilled_email=',
  smtpImapCouldNotAuth:
    'https://docs.saleshandy.com/en/articles/7041196-how-to-fix-smtp-imap-could-not-authenticate-error',
  smtpImapEmailNotFound:
    'https://docs.saleshandy.com/en/articles/6970075-how-to-fix-smtp-imap-email-not-found-error',
  smtpImapConnectionTimeOut:
    'https://docs.saleshandy.com/en/articles/7041212-how-to-fix-smtp-imap-connection-timeout-error',
  smtpImapOtherError:
    'https://docs.saleshandy.com/en/articles/7041222-how-to-fix-smtp-imap-other-error',
  pauseProspectInSequence:
    'https://docs.saleshandy.com/en/articles/6970073-how-to-pause-a-prospect-in-sequence',
  spintaxBlog:
    'https://docs.saleshandy.com/en/articles/6946631-what-is-spintax-how-to-use-it-with-saleshandy',
  emailInfrastructureFAQ:
    'https://docs.saleshandy.com/en/articles/10530994-email-infrastructure-in-saleshandy',
  coldEmailMasterClass:
    'https://www.saleshandy.com/cold-email-masterclass/?utm_source=inapp&utm_medium=inappsection&utm_campaign=coldemailmastery',
  intercomBaseUrl: 'https://api-iam.intercom.io',
  celloBaseUsrl: 'https://api.sandbox.cello.so/	',
  howToConnectGmailAccountWithSmtpImap:
    'https://docs.saleshandy.com/en/articles/6948265-how-to-connect-a-gmail-account-with-smtp-imap',
  howToConnectGmailAccountWithSmtpImapStep3:
    'https://docs.saleshandy.com/en/articles/6948265-how-to-connect-a-gmail-account-with-smtp-imap#h_6cddbd857b',
  howToConnectGmailAccountWithSmtpImapVideo: 'https://youtu.be/fUpKGwuncvQ',
  learnHowUnifiedInboxWorks:
    'https://docs.saleshandy.com/en/articles/6999237-unified-inbox-explained',
  trulyInboxForWarmupFaq:
    'https://docs.saleshandy.com/en/articles/7146556-transition-to-trulyinbox-for-email-warm-up',
  sequenceReport:
    'https://docs.saleshandy.com/en/articles/7237800-sequence-reports-explained',

  spfYtUrl: 'https://www.youtube.com/embed/EvZE4FEzF6Q',
  ctdYtUrl: 'https://www.youtube.com/embed/0KBK9bIggoc',
  dmarcYtUrl: 'https://www.youtube.com/embed/DrG1j0G1krg',
  emailAgeYtUrl: 'https://www.youtube.com/embed/rcv6PPyTn70',
  dmarcVideoUrl:
    'https://fast.wistia.com/embed/medias/vdbuo6sgk1?web_component=true&seo=true',
  ctdVideoUrl:
    'https://fast.wistia.com/embed/medias/p8hy5sssxu?web_component=true&seo=true',
  spfVideoUrl:
    'https://fast.wistia.com/embed/medias/8zoa6z1emh?web_component=true&seo=true',
  dkimVideoUrl:
    'https://fast.wistia.com/embed/medias/w4f79q2077?web_component=true&seo=true',
  mxRecordVideoUrl:
    'https://fast.wistia.com/embed/medias/d95lkfszwa?web_component=true&seo=true',
  sendingIntervalVideoUrl:
    'https://fast.wistia.com/embed/medias/k7wa1rsf0k?web_component=true&seo=true',
  domainIPBlacklistVideoUrl:
    'https://fast.wistia.com/embed/medias/j1853kgdbt?web_component=true&seo=true',
  emailAgeVideoUrl:
    'https://fast.wistia.com/embed/medias/exmf7bk9qw?web_component=true&seo=true',
  dailySendingQuotaVideoUrl:
    'https://fast.wistia.com/embed/medias/0v4ersqngk?web_component=true&seo=true',
  spfBlog:
    'https://docs.saleshandy.com/en/articles/8001502-spf-what-why-and-how-to-set-it-up',
  ctdBLog:
    'https://docs.saleshandy.com/en/articles/7991392-setting-up-your-custom-tracking-domain-step-by-step-guide',
  dmarcBlog:
    'https://docs.saleshandy.com/en/articles/8003992-dmarc-what-why-and-how-to-set-it-up',
  emailAgeBlog:
    'https://docs.saleshandy.com/en/articles/7876762-email-set-up-score-what-why-and-how-to-set-it-up#h_d746a318bc',
  emailSendingIntervalBlog:
    'https://docs.saleshandy.com/en/articles/6970057-email-sending-settings-limit-how-many-emails-can-i-send-with-saleshandy',
  domainAndIPBlacklistBlog:
    'https://docs.saleshandy.com/en/articles/10597760-how-to-delist-ip-and-domain-from-blacklist',
  dkimBlog:
    'https://docs.saleshandy.com/en/articles/8001406-dkim-what-why-and-how-to-set-it-up',
  ptrBlog:
    'https://docs.saleshandy.com/en/articles/13869042-how-to-check-ptr-reverse-dns-record-status-in-saleshandy',
  mxRecordBlog:
    'https://docs.saleshandy.com/en/articles/8637190-how-to-add-an-mx-records-in-godaddy',
  saleshandyPlansPricing:
    'https://docs.saleshandy.com/en/articles/11325097-saleshandy-plans-pricing-new',
  integration:
    'https://docs.saleshandy.com/en/collections/3820211-integrations',
  zapierIntegrationBlog:
    'https://docs.saleshandy.com/en/articles/8861470-zapier-integration',
  zapierIntegration: 'https://zapier.com/apps/saleshandy/integrations',
  videoPersonalizationBlog:
    'https://docs.saleshandy.com/en/articles/9614843-elevate-your-cold-email-strategy-with-personalized-video-campaigns',
  pitchlaneIntegration:
    'https://pitchlane.com/integrations/saleshandy?ref=Saleshandy',
  sendlerIntegration: 'https://sendler.ai?fpr=naitik13',
  sendsparkIntegration: 'https://sendspark.com/?via=saleshandy',
  weezlyIntegration: 'https://weezly.com/?aff=SaleshandyIntegration',
  bulkImportGuide:
    'https://docs.saleshandy.com/en/articles/7881940-bulk-email-import-explained',
  bulkImportSampleCSV:
    'https://v3artifacts.s3.us-west-2.amazonaws.com/161024/Connect%2BBulk%2BEmail%2BDemo%2B__%2BSaleshandy.csv',
  bulkImportSampleCSVWhitelabel:
    'https://v3artifacts.s3.us-west-2.amazonaws.com/Connect+Bulk+Email+Demo.csv',
  ccBccBlog:
    'https://docs.saleshandy.com/en/articles/7055488-sequence-settings-what-why-and-how-to-set-it-up#h_f79518846d',
  unsubscribeLinkTextBlogURL:
    'https://docs.saleshandy.com/en/articles/6969617-how-does-the-unsubscribe-link-text-work',
  unsubscribeHeaderBlogURL:
    'https://docs.saleshandy.com/en/articles/13869031-how-to-set-unsubscribe-in-email-header',
  agencyPortalVideoGuide: 'https://www.youtube.com/embed/pOvzJp84QI0',
  customTrackingDomainVideoGuide: 'https://www.youtube.com/embed/0KBK9bIggoc',
  doYouKnowWhyScheduledEmailsAreNotShown:
    'https://docs.saleshandy.com/en/articles/8286429-do-you-know-why-scheduled-emails-are-not-shown',
  planComparisonPDFURL:
    'https://v3artifacts.s3.us-west-2.amazonaws.com/downloads/Saleshandy+plans+comparison.pdf',
  prospectEngagement:
    'https://docs.saleshandy.com/en/articles/7237800-reports-what-why-and-how-to-set-it-up#h_b95ab79588',
  prospectOutcome:
    'https://docs.saleshandy.com/en/articles/7237800-reports-what-why-and-how-to-set-it-up#h_fb48cf48e3',
  emailEngagement:
    'https://docs.saleshandy.com/en/articles/7237800-reports-what-why-and-how-to-set-it-up#h_de9e535255',
  outOfOfficeBlog:
    'https://docs.saleshandy.com/en/articles/8535613-out-of-office-detection-auto-pause-and-resume',
  agencyPortalSignupURL:
    'https://agency.saleshandy.com/signup?utm_source=V3_inappagencytab&utm_medium=V3product&utm_campaign=product',
  g2ReviewSubmissionForm: 'https://forms.gle/tLnbisjNK67dKGE87',
  g2LeadFinderReviewSubmissionForm: 'https://forms.gle/hxBZmAJyBhPLBk1f6',
  startTrustpilotReviewLink: 'https://www.trustpilot.com/review/saleshandy.com',
  AMSButtonSequenceScoreURL:
    'https://www.saleshandy.com/account-management-service/?utm_source=AMS&utm_medium=saleshandy&utm_campaign=AMS_Sequence_Score&utm_id=ams-sequence-score',
  AMSButtonEmailSetupScoreURL:
    'https://www.saleshandy.com/account-management-service/?utm_source=AMS&utm_medium=saleshandy&utm_campaign=AMS_Email_Score&utm_id=ams-email-score',
  webhookBlogURL: 'https://docs.saleshandy.com/en/articles/9202403-webhook-new',
  webhookSetupGuideURL:
    'https://docs.saleshandy.com/en/articles/9202403-webhook-new#h_e0881be3d3',
  webhookExampleDataURL:
    'https://docs.saleshandy.com/en/articles/9207215-example-webhook-data',
  agencyOnboardingVideoURL:
    'https://fast.wistia.net/embed/iframe/cnj4a7b95u?seo=false&videoFoam=false',
  leadOnboardingVideoURL:
    'https://fast.wistia.net/embed/iframe/c0g7p8xi49?seo=false&videoFoam=false',
  clientPermissionsBlog:
    'https://docs.saleshandy.com/en/articles/9335104-client-permissions',
  dncBlogURL:
    'https://docs.saleshandy.com/en/articles/9439569-introducing-the-do-not-contact-list-a-new-feature-in-saleshandy',
  callDncBlogURL:
    'https://docs.saleshandy.com/en/articles/14818837-what-why-and-how-to-manage-do-not-call-lists-in-dialer',
  findYourDNSProvider:
    'https://docs.saleshandy.com/en/articles/6969623-how-to-check-your-dns-provider',
  whitelabelYoutubeURL:
    'https://fast.wistia.net/embed/iframe/mc1whpvvu6?seo=true&videoFoam=false',
  whitelabelKnowMoreURL:
    'https://docs.saleshandy.com/en/articles/9439052-white-label',
  variableTagsBlogURL: '',
  // 'https://docs.saleshandy.com/en/articles/9795619-variable-merge-tags-in-saleshandy',
  outreachOnboardingVideoURL:
    'https://fast.wistia.net/embed/iframe/cnj4a7b95u?seo=false&videoFoam=false',
  stepsCreatedVideoURL:
    'https://fast.wistia.net/embed/iframe/s5cow1py7q?seo=true&videoFoam=false',
  addProspectVideoURL:
    'https://fast.wistia.net/embed/iframe/8ltu5czw5v?seo=true&videoFoam=false',
  connectEmailAccountVideoURL:
    'https://fast.wistia.net/embed/iframe/7e3kcczr3j?seo=true&videoFoam=false',
  launchSequenceVideoURL:
    'https://fast.wistia.net/embed/iframe/otp7n9w2g1?seo=true&videoFoam=false',
  addClientsVideoURL:
    'https://fast.wistia.net/embed/iframe/lnuld49n2w?seo=true&videoFoam=false',
  sendingPriorityBlog:
    'https://docs.saleshandy.com/en/articles/10008162-sending-priority-in-saleshandy',
  safetySettingsSupport:
    'https://docs.saleshandy.com/en/articles/13905614-how-to-manage-safety-settings-in-saleshandy',
  customTrackingDomainSetupGuide:
    'https://docs.saleshandy.com/en/articles/7991392-setting-up-your-custom-tracking-domain-step-by-step-guide',
  linkTrackingNotRecommended:
    'https://docs.saleshandy.com/en/articles/6969595-why-we-do-not-recommend-link-tracking',
  trackExternalEmailsBlog:
    'https://docs.saleshandy.com/en/articles/10141100-enhanced-reply-tracking-in-unified-inbox',
  emailAccountSpf:
    'https://docs.saleshandy.com/en/articles/8001502-spf-what-why-and-how-to-set-it-up',
  emailAccountDmarc:
    'https://docs.saleshandy.com/en/articles/8003992-dmarc-what-why-and-how-to-set-it-up',
  emailAccountCustomDomain:
    'https://docs.saleshandy.com/en/articles/6921749-custom-tracking-domain-explained',
  howToRunMultichannelSequences:
    'https://docs.saleshandy.com/en/articles/10449816-how-to-run-multichannel-sequences-in-saleshandy',
  connectEmailAccountsVideoURL:
    'https://fast.wistia.net/embed/iframe/7e3kcczr3j?web_component=true&seo=true',
  emailInfrastructureVideoURL:
    'https://fast.wistia.net/embed/iframe/a7kutlqnad?web_component=true&seo=true',
  ssoSetUpBlog:
    'https://docs.saleshandy.com/en/articles/10717545-setting-up-sso-in-saleshandy',
  sequenceViewBlog:
    'https://docs.saleshandy.com/en/articles/10833856-smarter-sequence-view',
  slackCommunityURL:
    'https://join.slack.com/t/saleshandycommunity/shared_invite/zt-3jtxvigdv-6uJqRlmmYi~hmFC4~HhPNg',
  subsequenceVideoURL:
    'https://fast.wistia.net/embed/iframe/c0n8npmeff?web_component=true&seo=true',
  evCreditsFAQPage:
    'https://docs.saleshandy.com/en/articles/6921774-prospect-verification-why-should-i-use-email-verification-to-validate-the-prospects',
  inboxRadarSetupGuide:
    'https://docs.saleshandy.com/en/articles/11583280-how-to-test-your-email-deliverability-with-inbox-radar',
  creditRewardTerms: 'https://www.saleshandy.com/review-terms-of-service/',
  inboxRadarVideoUrl:
    'https://fast.wistia.net/embed/iframe/4abzsugr7k?web_component=true&seo=true',
  crmVideoUrl:
    'https://fast.wistia.net/embed/iframe/9x60c5hz14?web_component=true&seo=true',
  emailServiceProviderURL:
    'https://docs.saleshandy.com/en/articles/6969661-how-to-know-who-is-my-email-service-provider',
  calendlyDemoScheduleLink: 'https://calendly.com/d/ctbb-bns-yqc',
  aiCreditsReviewSubmissionForm:
    'https://docs.google.com/forms/d/e/1FAIpQLSfKua2_ZZnsbmCHLawB4PPSJL60tg39ymHjMvdPNrgLZ4zTaA/viewform',
  startG2ReviewLink: 'https://www.g2.com/products/saleshandy/reviews',
  aiProspectEnrichmentURL:
    'https://fast.wistia.net/embed/iframe/5idefh7a6x?web_component=true&seo=true',
  googleReviewSubmissionFormLink:
    'https://docs.google.com/forms/d/e/1FAIpQLSdX_XgDR6q2mvAFUlu345A1VOpWVrxDCj-d3f54mYxaX0gPzw/viewform',
  googleReviewLink:
    'https://www.google.com/search?q=saleshandy&sca_esv=b3eabebcbe652a55&rlz=1C5CHFA_enIN1141IN1141&ei=qLs7adifM7-MseMP0O-ykQQ&gs_ssp=eJzj4tVP1zc0TDYuKUquSCozYLRSNagwtjRNtTCxNEtMsjBOSTQwtzKoMDIxNbE0MUwyNLWwTDOyMPDiKk7MSS3OSMxLqQQAaEQS6Q&oq=saleshand&gs_lp=Egxnd3Mtd2l6LXNlcnAiCXNhbGVzaGFuZCoCCAAyFhAuGIAEGLEDGEMYxwEYigUYjgUYrwEyBRAAGIAEMgUQABiABDILEAAYgAQYkQIYigUyBRAAGIAEMgUQABiABDIKEAAYgAQYQxiKBTIKEAAYgAQYQxiKBTIFEAAYgAQyBRAAGIAEMiUQLhiABBixAxhDGMcBGIoFGI4FGK8BGJcFGNwEGN4EGOAE2AEBSMERUJQDWM8KcAN4AZABAJgByQGgAcwMqgEFMC44LjG4AQHIAQD4AQGYAg2gAvoTwgIKEAAYsAMY1gQYR8ICFBAuGIAEGJECGMcBGIoFGI4FGK8BwgILEAAYgAQYsQMYgwHCAg4QABiABBixAxiDARiKBcICCBAAGIAEGLEDwgIOEC4YgAQYsQMY0QMYxwHCAiMQLhiABBiRAhjHARiKBRiOBRivARiXBRjcBBjeBBjgBNgBAcICEBAAGIAEGLEDGEMYgwEYigXCAhMQLhiABBixAxjRAxhDGMcBGIoFwgITEC4YgAQYQxjHARiKBRiOBRivAcICEBAAGIAEGLEDGEMYyQMYigXCAggQLhiABBixA8ICCxAAGIAEGJIDGIoFwgIEEAAYA8ICIhAuGIAEGEMYxwEYigUYjgUYrwEYlwUY3AQY3gQY4ATYAQHCAhYQLhiABBixAxjRAxhDGIMBGMcBGIoFwgINEAAYgAQYsQMYQxiKBcICCBAAGIAEGMkDwgIIEAAYgAQYkgOYAwCIBgGQBgi6BgYIARABGBSSBwkzLjcuMi42LTGgB9BdsgcFMC43LjK4B5cNwgcIMC4xLjEwLjLIB0yACAA&sclient=gws-wiz-serp#lrd=0x395e8496ab83da07:0x2454941b1589f280,3,,,,',
});
